<template>
  <div>
    <el-upload
      ref="uploader"
      :action="action"
      :headers="headers"
      :data="{
        category: data.category,
        note: data.note || 'en',
      }"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :before-upload="pickedFile"
      :multiple="multiple"
      :file-list="fileList"
      :disabled="disabled"
      :show-file-list="false"
      :accept="accept"
    >
      <slot></slot>
    </el-upload>

    <!-- This HTML markup is copied from upload-list text -->
    <transition-group
      tag="ul"
      :class="[
        'el-upload-list',
        'el-upload-list--text',
        { 'is-disabled': disabled }
      ]"
      name="el-list"
      >
      <li
        v-for="(item, index) in uploaderList"
        :key="index"
        tabindex="0"
        class="el-upload-list__item is-success"
      >
        <span class="el-upload-list__item-name">
          <i class="el-icon-document"></i>

          <!-- Additional markup -->
          <span
            class="subtitle-uploader__select"
            v-if="typeof item.note === 'string'"
          >
            <el-select
              :value="item.note"
              placeholder="Select"
              size="mini"
              style="width: 160px;"
              filterable
              @change="(note) => handleLanguageUpdate(item, note)"
            >
              <el-option
                v-for="item in langs"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </span>
          {{ item.name }}

          <div style="clear: both;"></div>
        </span>


        <label class="el-upload-list__item-status-label">
          <i class="el-icon-upload-success el-icon-circle-check"></i>
        </label>
        <i
          class="el-icon-close"
          @click="handleRemove(item, fileList)"
        ></i>
        <i class="el-icon-close-tip">press delete to remove</i>

        <el-progress
          v-if="item.status === 'uploading'"
          :type="'line'"
          :stroke-width="2"
          :percentage="parsePercentage(item.percentage)">
        </el-progress>

      </li>
    </transition-group>


  </div>
</template>

<script>
import Vue from 'vue';
import langCodes from '@/assets/data/ISO693-1.json';

export default {
  props: {
    'file-list': {},
    'action': {},
    'data': {},
    'headers': {},
    'on-add': {},
    'on-remove': {},
    'on-success': {},
    'on-change': {},
    'multiple': {},
    'disabled': {
      type: Boolean,
      default: false,
    },
    'accept': {
      type: String,
      default: '*/*',
    },
  },
  data() {
    return {
      langs: Object.freeze(Object.keys(langCodes).map(key => ({
        value: key,
        label: langCodes[key].name,
      }))),
      isRendered: false,
    };
  },
  computed: {
    uploaderList() {
      return this.isRendered ? this.$refs.uploader.uploadFiles : [];
    },
  },
  methods: {
    handleRemove(file) {
      const oldFileList = this.uploaderList;
      const newFileList = oldFileList.filter(listFile => listFile.uid !== file.uid);

      this.onRemove(file, newFileList);
    },
    handleLanguageUpdate(file, newLanguage) {
      this.onChange(file, newLanguage);
    },
    parsePercentage(val) {
      return parseInt(val, 10);
    },
    pickedFile(rawFile) {
      const uploader = this.$refs.uploader.$children.find(child => child.name === 'file');
      const isSrtFile = rawFile.name.includes('.srt');

      if (!isSrtFile) {
        this.$message('You can only upload .srt files here');
      } else {
        uploader.uploadFiles(rawFile);
      }
      this.isAcceptedType=isSrtFile;
      return isSrtFile;
    },
  },
  mounted() {
    Vue.nextTick(() => {
      this.isRendered = true;
    });
  },
};
</script>

<style lang="scss" scoped>
.subtitle-uploader__select {
  margin-left: -4px;
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/FilesMedia/SubtitleUploader.vue